import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import SlideRightDialog from '../../../components/common/SlideRightDialog';
import Step1 from './Step1';
import Step2 from './Step2';
import PersonalInfoConsentForm from './PersonalInfoConsentForm';
import Step3 from './Step3';
import Step4 from './Step4';
import PersonalInfoConsent2Form from './PersonalInfoConsent2Form';
import { setReload } from '../eDocumentsSlice';
import InfoBanner from '../../../components/Banner';

//국세청 연동
const LinkToData = ({ isOpen, setIsOpen }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('eDocuments');
  const { eDocumentStatus } = useSelector(state => state.eDocuments);

  const [step, setStep] = useState(2);
  const [selectedItem, setSelectedItem] = useState(null);
  const [form, setForm] = useState({});
  const [check, setCheck] = useState({
    personalInfoConsent: false,
    personalInfoConsent2: false,
  });

  useEffect(() => {
    if (isOpen) {
      const { htmPdfUploadFlag } = eDocumentStatus;
      if (htmPdfUploadFlag == '1') {
        setStep(5);
      }
    }

    if (!isOpen) {
      setForm({});
      setSelectedItem(null);
    }
  }, [isOpen]);

  const stepHandler = step => {
    if (step == 7) {
      onClose();
      return;
    }
    setStep(step);
  };

  const onClose = () => {
    if (step === 3 || step === 6) {
      setStep(2);
      return;
    }
    dispatch(setReload());
    setCheck({
      personalInfoConsent: false,
      personalInfoConsent2: false,
    });
    setIsOpen(false);
    setStep(2);
  };

  const handleCheckChange = e => {
    setCheck({ ...check, [e.target.name]: !check[e.target.name] });
  };

  const personalInfoConsentHandler = name => {
    setCheck({ ...check, [name]: true });
    stepHandler(2);
  };

  const renderStep = () => {
    // if (step === 1) return <Step1 stepHandler={stepHandler} />;
    //성명 입력
    if (step === 2)
      return (
        <Step2
          stepHandler={stepHandler}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          check={check}
          handleCheckChange={handleCheckChange}
          isOpen={isOpen}
          form={form}
          setForm={setForm}
        />
      );
    // 개인정보 이용 동의(필수)
    if (step === 3)
      return (
        <PersonalInfoConsentForm
          stepHandler={stepHandler}
          personalInfoConsentHandler={personalInfoConsentHandler}
        />
      );
    // 개인정보 제3자 제공 동의(필수)
    if (step === 6)
      return (
        <PersonalInfoConsent2Form
          stepHandler={stepHandler}
          personalInfoConsentHandler={personalInfoConsentHandler}
        />
      );

    // 인증 화면
    if (step === 4) return <Step3 stepHandler={stepHandler} selectedItem={selectedItem} />;
    // 인증 완료
    if (step === 5) return <Step4 stepHandler={stepHandler} />;
  };

  return (
    <SlideRightDialog isOpen={isOpen} onClose={onClose} title={t('linkToData.title')}>
      <div className="displayFlexColumn" style={{ gap: '16px' }}>
        <InfoBanner
          title={t('linkToData.banner.title')}
          description={t('linkToData.banner.description')}
        />
        {renderStep()}
      </div>
    </SlideRightDialog>
  );
};

export default LinkToData;
